import { SnowboardModel } from '../types/snowboard';

export const snowboards: SnowboardModel[] = [
  {
    id: 'underdog',
    name: 'Underdog',
    description: 'Парк? Шред? Доска на каждый день?\n' +
    'Нет ничего более подходящего и \n' +
    'более оптимального, чем Твин-тип со\n' +
    'средней жесткостью и классическим \n' +
    'прогибом. Тут можно было бы и \n' +
    'закончить, однако как и для любого \n' +
    'Underdoga, здесь история только начинается...' + '\n\n',
    sizes: [
      { size: '148', available: true },
      { size: '151', available: true },
      { size: '155', available: true },
      { size: '155w', available: true },
      { size: '158w', available: true },
      { size: '161', available: true }
    ],
    imageUrl: './images/snowboards/underdog.webp'
  },
  {
    id: 'pixie',
    name: 'PIXIE',
    description: 'Ходят легенды, что эти мифические существа способны на все.\n' +
    'Женский Твин-тип с классическим \n' +
    'прогибом и средней жесткостью – \n' +
    'беспроигрышный выбор для парка или \n' +
    'на каждый день. \n\n' + '\n\n',
    sizes: [
      { size: '140', available: true },
      { size: '142', available: true },
      { size: '145', available: true },
      { size: '147', available: true },
      { size: '149', available: true }
    ],
    imageUrl: './images/snowboards/pixie.webp'
  },
  {
    id: 'fae',
    name: 'FAE',
    description: 'Глубоко в лесах живут мифические создания, созданные из чистых искр радости и света.\n\n' +
    'Эти магические спутницы всегда готовы помочь в нелегком пути и прощают даже серьезные ошибки.' +
    '\n\n' + '\n',
    sizes: [
      { size: '125', available: true },
      { size: '130', available: true },
      { size: '135', available: true }
    ],
    imageUrl: './images/snowboards/fae.webp'
  },
  {
    id: 'unit',
    name: 'UNIT',
    description: 'Каждый UnderDog, когда-то был Unitом. Мягкий, необычайно легкий Твин-тип, созданный специально, чтобы прощать ошибки и ускорять твой прогресс. Unit сделает так, чтобы ты получал удовольствие от процесса, сделает так, чтобы завтра ты точно пошел кататься снова.' +
    '\n\n',
    sizes: [
      { size: '125', available: true },
      { size: '130', available: true },
      { size: '135', available: true },
      { size: '140', available: true }
    ],
    imageUrl: './images/snowboards/unit.webp'
  },
  {
    id: 'amf',
    name: 'AM FISH',
    description: 'Позакладывать дуги на трассе, залететь в парк на пару кругов, попрыгать с трасс в пухлый, либо покатать паудэр в лесу. Когда мы думали какой должен быть наш первый фиш — мы подумали о чем-то универсальном.' +
    '\n\n' + '\n',
    sizes: [
      { size: '148', available: true },
      { size: '151', available: true },
      { size: '154', available: true },
      { size: '157', available: true },
      { size: '162', available: true }
    ],
    imageUrl: './images/snowboards/amf.webp'
  },
  {
    id: 'bcfr',
    name: 'BCFR',
    description: 'На вопрос: что для вас свобода в катании, мы бы ответили — пухлый снег, дропы, большие линии со стенок и простой внетрассовый шред по курорту с друзьями. И именно для этого построена эта модель. Акцент на внетрассовое катание, но при этом же прогнозируемая и управляемая на жестком снегу.',
    sizes: [
      { size: '157', available: true },
      { size: '159', available: true },
      { size: '162', available: true },
      { size: '165', available: true },
      { size: '165W', available: true }
    ],
    imageUrl: './images/snowboards/bcfr.webp'
  },
  {
    id: 'w_prototype',
    name: 'W_prototype',
    description: 'Women\'s specific all-mountain freestyle board 💃',
    sizes: [
      { size: '141', available: true },
      { size: '143', available: true },
      { size: '147', available: true }
    ],
    imageUrl: './images/snowboards/w_prototype.webp'
  }
];